export default {
	en: {
		'{{playerName}} joined!': '{{playerName}} joined!',
		'*Allows your data to be saved between devices': '*Allows your data to be saved between devices',
		'*^&$@%': '*^&$@%',
		'4 letters or more': '4 letters or more',
		About: 'About',
		Aboveboard: 'Aboveboard',
		'Aces are worth 1 point, face cards are worth 10, and numbered cards are worth their face value.': 'Aces are worth 1 point, face cards are worth 10, and numbered cards are worth their face value.',
		Achievements: 'Achievements',
		'Already have an account?': 'Already have an account?',
		Avatar: 'Avatar',
		'Big Gin': 'Big Gin',
		'Big Gin (Opponent)': 'Big Gin (Opponent)',
		'Big Gin Percent': 'Big Gin Percent',
		'Big Gin Percent (Opponent)': 'Big Gin Percent (Opponent)',
		'Bring it on': 'Bring it on',
		Category: 'Category',
		Change: 'Change',
		Chat: 'Chat',
		'Close Game': 'Close Game',
		Continue: 'Continue',
		'Crazy Ninja': 'Crazy Ninja',
		CrazyNinja: 'CrazyNinja',
		Create: 'Create',
		'Create Account': 'Create Account',
		'Create Room': 'Create Room',
		'Create or join an existing room': 'Create or join an existing room',
		Deadwood: 'Deadwood',
		'Deadwood (Opponent)': 'Deadwood (Opponent)',
		'Deadwood Avg': 'Deadwood Avg',
		'Deadwood Avg (Opponent)': 'Deadwood Avg (Opponent)',
		'Deadwood Max': 'Deadwood Max',
		Dealing: 'Dealing',
		Delete: 'Delete',
		'Delete All': 'Delete All',
		"Don't have an account?": "Don't have an account?",
		'Each player is dealt 10 cards if there are only two players, and 7 cards if there are more.': 'Each player is dealt 10 cards if there are only two players, and 7 cards if there are more.',
		Easy: 'Easy',
		'Email Login': 'Email Login',
		Emojis: 'Emojis',
		Enter: 'Enter',
		'Finding server...': 'Finding server...',
		'Find a Game': 'Find a Game',
		'Forgot Password': 'Forgot Password',
		Gameplay: 'Gameplay',
		'Gift in crib': 'Gift in crib',
		Gin: 'Gin',
		'Gin (Opponent)': 'Gin (Opponent)',
		'Gin Avg': 'Gin Avg',
		'Gin Percent (Opponent)': 'Gin Percent (Opponent)',
		'Gin Rummy is typically played with 2 players.': 'Gin Rummy is typically played with 2 players.',
		'Good Game': 'Good Game',
		'Good run': 'Good run',
		'Got lucky': 'Got lucky',
		'Had enough?': 'Had enough?',
		Hard: 'Hard',
		'Having fun?': 'Having fun?',
		Hello: 'Hello',
		Hi: 'Hi',
		'How To Play': 'How To Play',
		'How about 2 out of 3?': 'How about 2 out of 3?',
		"If the opponent can reduce their deadwood to fewer points than the knocker's, they score the difference and receive a 10-point bonus.": "If the opponent can reduce their deadwood to fewer points than the knocker's, they score the difference and receive a 10-point bonus.",
		"If the opponent has no unmatched cards, it's called going \"Gin,\" and the knocker is penalized.": "If the opponent has no unmatched cards, it's called going \"Gin,\" and the knocker is penalized.",
		Impossible: 'Impossible',
		'Its real': 'Its real',
		Knocking: 'Knocking',
		Leaderboard: 'Leaderboard',
		Level: 'Level',
		Levels: 'Levels',
		Loading: 'Loading',
		Login: 'Login',
		'Login as Guest': 'Login as Guest',
		'Login to facebook to use your facebook profile': 'Login to facebook to use your facebook profile',
		'Login with Email': 'Login with Email',
		'Login with Facebook': 'Login with Facebook',
		'Loss Streak': 'Loss Streak',
		Looking: 'Looking',
		'Matches Played': 'Matches Played',
		'Maybe next time': 'Maybe next time',
		Medium: 'Medium',
		Melding: 'Melding',
		'More Games': 'More Games',
		Name: 'Name',
		'Nice Hand': 'Nice Hand',
		'Nicely played': 'Nicely played',
		No: 'No',
		'No Skunk': 'No Skunk',
		'No lurch': 'No lurch',
		'No thank you': 'No thank you',
		Nooooooooooo: 'Nooooooooooo',
		OK: 'OK',
		Objective: 'Objective',
		Online: 'Online',
		Oops: 'Oops',
		Ouch: 'Ouch',
		Phrases: 'Phrases',
		Play: 'Play',
		'Play Again?': 'Play Again?',
		'Play a Friend': 'Play a Friend',
		'Players take turns to draw and discard cards, trying to form sets and runs.': 'Players take turns to draw and discard cards, trying to form sets and runs.',
		'Players in room': 'Players in room',
		Points: 'Points',
		'Points (Opponent)': 'Points (Opponent)',
		'Points Avg': 'Points Avg',
		'Points Avg (Opponent)': 'Points Avg (Opponent)',
		'Points Last': 'Points Last',
		'Points Max': 'Points Max',
		'Points Win Avg': 'Points Win Avg',
		'Points Win Avg (Opponent)': 'Points Win Avg (Opponent)',
		'Private Room': 'Private Room',
		Profile: 'Profile',
		Random: 'Random',
		Rank: 'Rank',
		'Rate Game': 'Rate Game',
		Rating: 'Rating',
		'Rematch?': 'Rematch?',
		'Restore Data': 'Restore Data',
		'room name': 'room name',
		'Rounds Lost': 'Rounds Lost',
		'Rounds Lost (Opponent)': 'Rounds Lost (Opponent)',
		'Rounds Played': 'Rounds Played',
		'Rounds Played (Opponent)': 'Rounds Played (Opponent)',
		'Rounds Won': 'Rounds Won',
		'Rounds Won (Opponent)': 'Rounds Won (Opponent)',
		Scoring: 'Scoring',
		'See More Games': 'See More Games',
		'Select an avatar': 'Select an avatar',
		'Send Feedback': 'Send Feedback',
		Share: 'Share',
		'Share the app?': 'Share the app?',
		Sorry: 'Sorry',
		Statistics: 'Statistics',
		'Start Game?': 'Start Game?',
		Store: 'Store',
		'Thank You': 'Thank You',
		Thanks: 'Thanks',
		'The game is played over several rounds, and the first player to reach a set number of points (commonly 100) wins.': 'The game is played over several rounds, and the first player to reach a set number of points (commonly 100) wins.',
		'The main goal is to form sets (three or four cards of the same rank) and runs (three or more cards in sequence of the same suit).': 'The main goal is to form sets (three or four cards of the same rank) and runs (three or more cards in sequence of the same suit).',
		"The opponent can lay off their unmatched cards onto the knocking player's sets and runs.": "The opponent can lay off their unmatched cards onto the knocking player's sets and runs.",
		"The player who knocks scores the difference in points between their deadwood and the opponent's deadwood.": "The player who knocks scores the difference in points between their deadwood and the opponent's deadwood.",
		'The ultimate aim is to have as few unmatched cards as possible.': 'The ultimate aim is to have as few unmatched cards as possible.',
		'This will delete all of your data': 'This will delete all of your data',
		'To knock, a player must have a hand where the unmatched cards (deadwood) total 10 or fewer points.': 'To knock, a player must have a hand where the unmatched cards (deadwood) total 10 or fewer points.',
		Undercut: 'Undercut',
		'Undercut (Opponent)': 'Undercut (Opponent)',
		'Undercut Percent': 'Undercut Percent',
		'Undercut Percent (Opponent)': 'Undercut Percent (Opponent)',
		Undercutting: 'Undercutting',
		'Well played': 'Well played',
		'When a player has a complete hand, they can "knock" to signal the end of the round.': 'When a player has a complete hand, they can "knock" to signal the end of the round.',
		'Win Rate': 'Win Rate',
		'Win Streak': 'Win Streak',
		'Win Streak Max': 'Win Streak Max',
		Wins: 'Wins',
		Yes: 'Yes',
		"You're welcome": "You're welcome",
		'Removed from the game for inactivity': 'Removed from the game for inactivity',
		'Please check your connection.': 'Please check your connection.',
		'You appear to be offline.': 'You appear to be offline.',
	},
	fr: {
		'*Allows your data to be saved between devices': "*Permet à vos données d'être enregistrées entre les appareils",
		'*^&$@%': '*^&$@%',
		About: 'À propos',
		Aboveboard: 'Honnête',
		'Aces are worth 1 point, face cards are worth 10, and numbered cards are worth their face value.': 'Les as valent 1 point, les faces 10 et les cartes numérotées leur valeur faciale.',
		Achievements: 'Succès',
		'Already have an account?': 'Vous avez déjà un compte?',
		Avatar: 'Avatar',
		'Big Gin': 'Gros Gin',
		'Big Gin (Opponent)': 'Big Gin (Adversaire)',
		'Big Gin Percent': 'Pourcentage de Big Gin',
		'Big Gin Percent (Opponent)': 'Pourcentage de Big Gin (Adversaire)',
		'Bring it on': 'Allez',
		Category: 'Catégorie',
		Change: 'Changer',
		Chat: 'Bavarder',
		'Close Game': 'Match Serré',
		Continue: 'Continuer',
		'Crazy Ninja': 'Ninja Fou',
		CrazyNinja: 'CrazyNinja',
		Create: 'Créer',
		'Create Account': 'Créer un compte',
		'Create Room': 'Créer une chambre',
		'Create or join an existing room.': 'Créez ou rejoignez une salle existante.',
		Deadwood: 'Bois morts',
		'Deadwood (Opponent)': 'Bois morts (Adversaire)',
		'Deadwood Avg': 'Bois morts Moyenne',
		'Deadwood Avg (Opponent)': 'Bois morts Moyenne (Adversaire)',
		'Deadwood Max': 'Bois morts Max',
		Dealing: 'Distribuer des cartes',
		Delete: 'Effacer',
		'Delete All': 'Supprimer tout',
		"Don't have an account?": "Vous n'avez pas de compte?",
		'Each player is dealt 10 cards if there are only two players, and 7 cards if there are more.': "Chaque joueur reçoit 10 cartes s'il n'y a que deux joueurs, et 7 cartes s'il y en a plus.",
		Easy: 'Facile',
		'Email Login': 'Connectez-vous e-mail',
		Emojis: 'Emojis',
		Enter: 'Entrer',
		'Finding server...': 'Trouver un serveur...',
		'Forgot Password': 'Mot de passe oublié',
		Gameplay: 'Gameplay',
		'Gift in crib': 'Cadeau dans le crible',
		Gin: 'Gin',
		'Gin (Opponent)': 'Gin (Adversaire)',
		'Gin Avg': 'Gin Moyenne',
		'Gin Percent (Opponent)': 'Gin Pourcentage (Adversaire)',
		'Gin Rummy is typically played with 2 players.': 'Le Gin Rummy se joue généralement à deux joueurs.',
		'Good Game': 'Bonne partie',
		'Good run': 'Belle suite',
		'Got lucky': "J'ai eu de la chance",
		'Had enough?': 'Tu en as assez?',
		Hard: 'Difficile',
		'Having fun?': 'Vous vous amusez ?',
		Hello: 'Allô',
		Hi: 'Bonjour',
		'How To Play': 'Comment Jouez',
		'How about 2 out of 3?': 'Un 2 de 3?',
		"If the opponent can reduce their deadwood to fewer points than the knocker's, they score the difference and receive a 10-point bonus.": "Si l'adversaire parvient à réduire son bois mort à moins de points que celui du heurtoir, il marque la différence et reçoit un bonus de 10 points.",
		"If the opponent has no unmatched cards, it's called going \"Gin,\" and the knocker is penalized.": "Si l'adversaire n'a pas de cartes inégalées, cela s'appelle «Gin» et le heurteur est pénalisé.",
		Impossible: 'Impossible',
		'Its real': "C'est réel",
		Knocking: 'Frapper',
		Language: 'La langue',
		Leaderboard: 'Classement',
		Level: 'Niveaux',
		Levels: 'Niveaux',
		Loading: 'Chargement',
		Login: 'Login',
		'Login as Guest': "Se connecter en tant qu'invité",
		'Login to facebook to use your facebook profile': 'Connectez-vous à Facebook pour utiliser votre profil Facebook',
		'Login with Email': 'Connectez-vous e-mail',
		'Login with Email (Full)': 'Connectez-vous avec e-mail',
		'Login with Facebook': 'Connectez-vous Facebook',
		'Login with Facebook (Full)': 'Connectez-vous avec Facebook',
		'Loss Streak': 'Série de défaites',
		'Matches Played': 'Matches joués',
		'Maybe next time': 'Peut-être la prochaine fois',
		Medium: 'Médium',
		Melding: 'Fusion',
		'More Games': 'Plus de jeux',
		Name: 'Nom',
		'Nice Hand': 'Belle main',
		'Nicely played': 'Bien joué',
		No: 'Non',
		'No Skunk': 'Pas de skunk',
		'No lurch': 'Pas de problème',
		'No thank you': 'Non, merci',
		Nooooooooooo: 'Nonnnn!',
		OK: 'OK',
		Objective: 'Objectif',
		Online: 'En ligne',
		Oops: 'Oups!',
		Ouch: 'Aie',
		Phrases: 'Phrases',
		Play: 'Jouer',
		'Play Again?': 'Une autre partie?',
		'Play a Friend': 'Défier un ami',
		'Players take turns to draw and discard cards, trying to form sets and runs.': 'Les joueurs tirent et rejettent des cartes à tour de rôle, en essayant de former des séries et des séries.',
		Points: 'Points',
		'Points (Opponent)': 'Points (Adversaire)',
		'Points Avg': 'Points Moyenne',
		'Points Avg (Opponent)': 'Points Moyenne (Adversaire)',
		'Points Last': 'Points Dernière',
		'Points Max': 'Points Max',
		'Points Win Avg': 'Points Gagner Moyenne',
		'Points Win Avg (Opponent)': 'Points Gagner Moyenne (Adversaire)',
		'Private Room': 'Chambre privée',
		Profile: 'Profile',
		Random: 'Aléatoire',
		Rank: 'Rang',
		'Rate Game': 'Jeu de tarification',
		Rating: 'Note',
		'Rematch?': 'Rematch?',
		'Restore Data': 'Réinitialiser le data',
		'Rounds Lost': 'Rounds perdus',
		'Rounds Lost (Opponent)': 'Rounds perdus (Adversaire)',
		'Rounds Played': 'Rondes jouées',
		'Rounds Played (Opponent)': 'Rondes jouées (Adversaire)',
		'Rounds Won': 'Tours gagnés',
		'Rounds Won (Opponent)': 'Tours gagnés (Adversaire)',
		Scoring: 'Notation',
		'See More Games': 'Voir plus de jeux',
		'Select an avatar': 'Sélectionnez un avatar',
		'Send Feedback': 'Envoyer des commentaires',
		Share: 'Partager',
		'Share the app?': "Partager l'application ?",
		Sorry: 'Désolé',
		Statistics: 'Statistiques',
		Store: 'Boutique',
		'Thank You': 'Merci à toi',
		Thanks: 'Merci',
		'The game is played over several rounds, and the first player to reach a set number of points (commonly 100) wins.': 'Le jeu se joue en plusieurs tours et le premier joueur à atteindre un nombre défini de points (généralement 100) gagne.',
		'The main goal is to form sets (three or four cards of the same rank) and runs (three or more cards in sequence of the same suit).': "L'objectif principal est de former des séries (trois ou quatre cartes de la même valeur) et des suites (trois cartes ou plus dans l'ordre et de la même couleur).",
		"The opponent can lay off their unmatched cards onto the knocking player's sets and runs.": "L'adversaire peut poser ses cartes non appariées sur les sets et les pistes du joueur qui a frappé.",
		"The player who knocks scores the difference in points between their deadwood and the opponent's deadwood.": "Le joueur qui frappe marque la différence en points entre son bois mort et celui de l'adversaire.",
		'The ultimate aim is to have as few unmatched cards as possible.': "Le but ultime est d'avoir le moins de cartes non appariées possible.",
		'This will delete all of your data': 'Cela supprimera toutes vos données',
		'To knock, a player must have a hand where the unmatched cards (deadwood) total 10 or fewer points.': 'Pour frapper, un joueur doit avoir une main dont les cartes non appariées (bois mort) totalisent 10 points ou moins.',
		'Type a message': 'Tapez un message',
		Undercut: 'Sous-coupe',
		'Undercut (Opponent)': 'Sous-coupe (Adversaire)',
		'Undercut Percent': 'Sous-coupe Pourcentage',
		'Undercut Percent (Opponent)': 'Sous-coupe Pourcentage (Adversaire)',
		Undercutting: 'Sous-cotation',
		'Well played': 'Bien joué',
		'When a player has a complete hand, they can "knock" to signal the end of the round.': "Lorsqu'un joueur a une main complète, il peut «frapper» pour signaler la fin du tour.",
		'Win Rate': 'Taux de réussite',
		'Win Streak': 'Série de victoires',
		'Win Streak Max': 'Série de victoires Max',
		Wins: 'Victoires',
		Yes: 'Oui',
		You: 'Vous',
		'You Win': 'Vous gagnez!',
		"You're welcome": 'De rien',
	},
};
